export const i18nConfig = {
  ...(process.env.NEXT_PUBLIC_SHOW_LANGUAGE_SWITCHER === 'true'
    ? {
        locales: ['en-US', 'fr-CA'],
      }
    : { locales: ['en-US'] }),

  defaultLocale: 'en-US',
};
